import { Component } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default class PayoutTableButtons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      selected: [],
      customConsent: null,
    };
  }

  getconsent = () => {
    let selectedPayouts = this.props.getSelected();
    let result = {};
    for (var i = 0; i < selectedPayouts.length; i++) {
      result[selectedPayouts[i].Id] = selectedPayouts[i].AccountId;
    }

    var token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
    var req = new XMLHttpRequest();
    req.open("POST", "/api/admin/autogiro/files/consent", true);
    req.responseType = "blob";
    req.setRequestHeader("Authorization", "Bearer " + token);
    req.setRequestHeader("Content-Type", "application/json");
    req.onload = () => {
      var blob = req.response;
      var fileName = "BFEP.IAGAG.537531.180703.133827";
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };
    req.send(JSON.stringify(result));
  };

  changeCustomConsent = (event) => {
    this.setState({
      ...this.state,
      customConsent: event.target.value,
    });
  };

  getCustomConsent = () => {
    let result = JSON.parse(this.state.customConsent);

    var token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
    var req = new XMLHttpRequest();
    req.open("POST", "/api/admin/autogiro/files/consent", true);
    req.responseType = "blob";
    req.setRequestHeader("Authorization", "Bearer " + token);
    req.setRequestHeader("Content-Type", "application/json");
    req.onload = () => {
      var blob = req.response;
      var fileName = "BFEP.IAGAG.537531.180703.133827";
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };
    req.send(JSON.stringify(result));
  };

  getPain = () => {
    let result = {};
    let selected = this.props.getSelected();
    for (var i = 0; i < selected.length; i++) {
      result[selected[i].Id] = selected[i].Id;
    }

    var token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
    var req = new XMLHttpRequest();
    req.open("POST", "/api/admin/autogiro/files/pain", true);
    req.responseType = "blob";
    req.setRequestHeader("Authorization", "Bearer " + token);
    req.setRequestHeader("Content-Type", "application/json");
    req.onload = () => {
      var blob = req.response;
      var fileName = "Pain";
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };
    req.send(JSON.stringify(result));
  };

  payoutAll = () => {
    this.props.registerPayouts(this.state.selected.map((object) => object.Id));
    this.hidePayout();
  };

  showPayout = () => {
    this.setState({ open: true, selected: this.props.getSelected() });
  };

  hidePayout = () => {
    this.setState({ open: false });
  };

  getContent = () => {
    return (
      <div>
        <ul>
          {this.state.selected.map((financing) => {
            if (financing.payout.fetched) {
              return (
                <li key={financing.Id}>
                  SSN: {financing.payout.data.SSN} / BankNumber{" "}
                  {financing.payout.data.BankNumber.Number} / Amount{" "}
                  {financing.payout.data.CreditAmount.Amount}
                  <hr />
                </li>
              );
            }

            return <li key="n-d">data no loaded</li>;
          })}
        </ul>
      </div>
    );
  };

  render() {
    let content = this.getContent();
    let actions = [
      <Button key="1" variant="outlined" onClick={this.hidePayout}>
        Cancel
      </Button>,
      <Button
        key="2"
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.payoutAll}
      >
        Confirm
      </Button>,
    ];

    //let selected = this.props.getSelected();

    return (
      <div>
        {!this.props.isMpl ? (
          <Card>
            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1c-content"
                id="panel1c-header"
              >
                <CardHeader title="Custom consent generation" />
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <CardActions>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.getCustomConsent}
                  >
                    Generate custom consent file
                  </Button>
                </CardActions>
                <CardContent>
                  <textarea
                    value={this.state.customConsent}
                    onChange={this.changeCustomConsent}
                  />
                </CardContent>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </Card>
        ) : undefined}

        {!this.props.isMpl ? (
          <Button
            variant="contained"
            color="primary"
            onClick={this.getPain}
            style={{ marginRight: "3px" }}
          >
            Generate pain file
          </Button>
        ) : undefined}
        {!this.props.isMpl ? (
          <Button
            variant="contained"
            color="primary"
            onClick={this.getconsent}
            style={{ marginRight: "3px" }}
          >
            Generate consent
          </Button>
        ) : undefined}
        <Button variant="contained" color="primary" onClick={this.showPayout}>
          Payout Selected
        </Button>
        <Dialog
          title="Confirm Payouts"
          modal={false}
          open={this.state.open}
          bodyStyle={{ overflow: "auto" }}
          onClose={this.handleClose}
        >
          <DialogContent>{content}</DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}
